(function () {
  const STOREFRONT_TOKEN = '13ea30f6d180f0fd945753954965649c';
  const SHOP_DOMAIN = 'croparts.dk';
  const API_VERSION = '2024-01';

  async function queryStorefront(searchTerm) {
    const response = await fetch(`https://${SHOP_DOMAIN}/api/${API_VERSION}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({
        query: `{
          search(query: "${searchTerm.replace(/"/g, '')}", types: PRODUCT, first: 8) {
            edges {
              node {
                ... on Product {
                  id
                  title
                  handle
                  featuredImage {
                    url(transform: { maxWidth: 400, maxHeight: 400 })
                    altText
                  }
                  priceRange {
                    minVariantPrice {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
          }
        }`
      })
    });
    const data = await response.json();
    return data?.data?.search?.edges?.map(e => e.node) || [];
  }

  function formatPrice(amount, currencyCode) {
    return new Intl.NumberFormat('da-DK', {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0
    }).format(parseFloat(amount));
  }

  function getNumericId(gid) {
    return gid.split('/').pop();
  }

  function buildCard(product) {
    const price = formatPrice(
      product.priceRange.minVariantPrice.amount,
      product.priceRange.minVariantPrice.currencyCode
    );
    const img = product.featuredImage?.url
      ? `<img src="${product.featuredImage.url}" alt="${product.featuredImage.altText || product.title}" class="resource-card__image" loading="lazy">`
      : '';

    return `
      <li class="predictive-search-results__card predictive-search-results__card--product"
          data-product-id="${getNumericId(product.id)}"
          ref="resultsItems[]"
          on:keydown="/onSearchKeyDown">
        <a href="/products/${product.handle}" class="resource-card resource-card--link">
          <span class="visually-hidden">${product.title}</span>
          <div class="resource-card__aspect-ratio" style="--resource-card-aspect-ratio: 4 / 5;">
            ${img}
          </div>
          <div class="resource-card__content">
            <p class="resource-card__title">${product.title}</p>
            <p class="resource-card__price">${price}</p>
          </div>
        </a>
      </li>`;
  }

  function injectIntoDropdown(searchTerm) {
    const input = document.querySelector('predictive-search-component input[type="search"]');
    if (!input || input.value.trim() !== searchTerm) return;

    const component = input.closest('predictive-search-component');
    if (!component) return;

    const resultsContainer = component.querySelector('#predictive-search-results');
    if (!resultsContainer) return;

    queryStorefront(searchTerm).then(products => {
      if (input.value.trim() !== searchTerm) return;

      // Hide "no results" if we have results
      if (products.length > 0) {
        const noResults = resultsContainer.querySelector('.predictive-search-results__no-results');
        if (noResults) noResults.style.display = 'none';
      }

      const existingIds = new Set(
        [...resultsContainer.querySelectorAll('[data-product-id]')]
          .map(el => el.dataset.productId)
      );

      const newProducts = products.filter(p => !existingIds.has(getNumericId(p.id)));
      if (!newProducts.length) return;

      // Target the native products section directly
      let productsSection = resultsContainer.querySelector('#predictive-search-products');

      if (!productsSection) {
        // Create it matching native structure exactly
        productsSection = document.createElement('div');
        productsSection.id = 'predictive-search-products';
        productsSection.className = 'predictive-search-results__products';
        productsSection.innerHTML = `
          <h4 class="predictive-search-results__title">Produkter</h4>
          <ul class="predictive-search-results__list predictive-search-results__wrapper-products list-unstyled" role="listbox" aria-label="Produkter"></ul>`;

        const searchResults = resultsContainer.querySelector('[data-search-results]');
        if (searchResults) searchResults.appendChild(productsSection);
      } else {
        // Native section exists — ensure our title isn't duplicated
        if (!productsSection.querySelector('.predictive-search-results__title')) {
          productsSection.insertAdjacentHTML('afterbegin',
            `<h4 class="predictive-search-results__title">Produkter</h4>
             <ul class="predictive-search-results__list predictive-search-results__wrapper-products list-unstyled" role="listbox" aria-label="Produkter"></ul>`
          );
        }
      }

      const list = productsSection.querySelector('ul');
      if (list) newProducts.forEach(p => list.insertAdjacentHTML('beforeend', buildCard(p)));

    }).catch(() => {});
  }

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!input.closest('predictive-search-component')) return;

    const searchTerm = input.value.trim();
    if (!searchTerm) return;

    setTimeout(() => injectIntoDropdown(searchTerm), 400);
  }, true);

})();